import { PopoverIframeComponent } from "./popover-iframe/popover-iframe.component";
import { PopoverWebviewComponent } from "./popover-webview/popover-webview/popover-webview.component";
import { PopoverContentComponent } from "./popover-content/popover-content.component";
import { PopoverSessionStatsComponent } from "./popover-session-stats/popover-session-stats.component";
import { PopoverFavouritesComponent } from "./popover-favourites/popover-favourites.component";
import { PopoverSelfExcludeComponent } from "./popover-self-exclude/popover-self-exclude.component";
import { VipTermsComponent } from "./popover-vipterms/popover-vipterms.component";
import { PopoverAlertComponent } from "./popover-alert/popover-alert.component";
import { PopoverStandardConfirmComponent } from "./popover-standard-confirm/popover-standard-confirm.component";
import { PopoverReconfirmationComponent } from "./popover-reconfirmation/popover-reconfirmation.component";
import { PopoverGameHistoryDetailsComponent } from "./popover-game-history-details/popover-game-history-details.component";
import { PopoverMarketingComponent } from "./popover-marketing/popover-marketing.component";
import { PopoverAgreementComponent } from "./popover-agreement/popover-agreement.component";
import { PopoverDarkWebviewComponent } from "./popover-webview/popover-dark-webview/popover-dark-webview.component";
import { FancyPopoverComponent } from "./fancy-popover/fancy-popover.component";
import { BonusContentPage } from "./bonus-content/bonus-content.page";
import { SettingsComponent } from "../pages/settings/settings.component";
import { PopoverProcessingComponent } from "./popover-processing/popover-processing.component"
import { StandardPopoverPage } from "./standard-popover/standard-popover.page"
import { PopoverTrackConsentComponent } from "./popover-track-consent/popover-track-consent.component";
import { PopoverBiometricComponent } from "./popover-biometric/popover-biometric.component"
import { BonusCollectionComponent } from "../components/shop/bonus-collection/bonus-collection.component"
import { GlobalErrorPopoverComponent } from '../components/global-error-popover/global-error-popover.component';
import { GlobalErrorBlockSitePopover } from "./global-error-block-site/global-error-block-site";

const popoverFactory: Object = {
	FancyPopoverComponent: FancyPopoverComponent,
	PopoverAlertComponent: PopoverAlertComponent,
	PopoverWebview: PopoverWebviewComponent,
	PopoverDarkWebview: PopoverDarkWebviewComponent,
	VipTermsComponent: VipTermsComponent,
	PopoveriFrame: PopoverIframeComponent,
	PopoverContent: PopoverContentComponent,
	PopoverSessionStats: PopoverSessionStatsComponent,
	PopoverFavourites: PopoverFavouritesComponent,
	PopoverSelfExcludeComponent: PopoverSelfExcludeComponent,
	PopoverStandardConfirmComponent: PopoverStandardConfirmComponent,
	PopoverGameHistoryDetailsComponent: PopoverGameHistoryDetailsComponent,
	PopoverMarketingComponent: PopoverMarketingComponent,
	PopoverAgreementComponent: PopoverAgreementComponent,
	PopoverReconfirmation: PopoverReconfirmationComponent,
	PopoverProcessingComponent: PopoverProcessingComponent,
	BonusContentPage: BonusContentPage,
	StandardPopoverPage: StandardPopoverPage,
	SettingsComponent: SettingsComponent,
	PopoverTrackConsentComponent: PopoverTrackConsentComponent,
	PopoverBiometricComponent: PopoverBiometricComponent,
	BonusCollectionComponent: BonusCollectionComponent,
	GlobalErrorPopoverComponent: GlobalErrorPopoverComponent,
	GlobalErrorBlockSitePopover: GlobalErrorBlockSitePopover
};

export const PopoverClass = className => {
	if (className in popoverFactory) {
		return popoverFactory[className];
	}
	return console.log(`"No popover match for " + ${className}`);
};